import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY].GET_REGULATIONS_FINANCE_PRODUCTIVITY]: {
		url:'/company/:companyId/regulations/:regulationId/finance_productivity/',
	}
}